import React from "react";
import { computeIVA, fmtMXN } from "@/lib/iva";

/**
 * Muestra un precio de forma compacta con leyenda "IVA incluido" o "Sin IVA".
 * Uso: <PriceLabel price={service.price} ivaIncluded={service.iva_included} />
 */
export function PriceLabel({ price, ivaIncluded = true, size = "base", testId, className = "" }) {
  const sizeClass = { xs: "text-xs", sm: "text-sm", base: "text-base", lg: "text-lg", xl: "text-xl" }[size] || "text-base";
  return (
    <span className={`inline-flex items-baseline gap-1.5 ${className}`} data-testid={testId}>
      <span className={`font-semibold ${sizeClass}`}>{fmtMXN(price)}</span>
      <span className="text-[10px] text-slate-500 tracking-wider uppercase">
        {ivaIncluded ? "IVA incluido" : "Sin IVA"}
      </span>
    </span>
  );
}

/**
 * Desglose completo del precio (usado en confirmaciones, tickets, billing).
 * Uso: <PriceBreakdown total={350} ivaIncluded={true} />
 */
export function PriceBreakdown({ total, ivaIncluded = true, label = "Total", testId }) {
  const b = computeIVA(total, ivaIncluded);
  if (!b.hasIva) {
    return (
      <div className="space-y-1 text-sm" data-testid={testId}>
        <div className="flex justify-between"><span className="text-slate-500">{label}</span><span className="font-semibold">{fmtMXN(b.total)}</span></div>
        <p className="text-[10px] text-slate-400 uppercase tracking-wider">Sin IVA (exento)</p>
      </div>
    );
  }
  return (
    <div className="space-y-1 text-sm" data-testid={testId}>
      <div className="flex justify-between"><span className="text-slate-500">Subtotal</span><span>{fmtMXN(b.subtotal)}</span></div>
      <div className="flex justify-between"><span className="text-slate-500">IVA (16%)</span><span>{fmtMXN(b.iva)}</span></div>
      <div className="flex justify-between font-semibold pt-1 border-t border-slate-200"><span>{label}</span><span>{fmtMXN(b.total)}</span></div>
    </div>
  );
}
